module.exports = __webpack_public_path__ + "img/banner-2.f57152d8.png";